/*
 * Packages: WebVideo.LiveVideoFeed
 * Version: $Id$
 * Copyright (c) 2012-2018 Sergey Leonov
 */

function LiveVideoFeed($, settings) {
  //private
  var opts = $.extend({}, settings);

  function getGalleryFile(identity, servURI, galleryContext, fileName) {
    var url = galleryContext;
    if(url === undefined) {
      url = servURI.replace('rtmp://', location.protocol+'//');
      url = url.substring(0, url.substring(8).search(/(:\d)|\//)+8) + "/templates/galleries/";
    }
    var id = identity.substring(5);
    if(id.length > 3) id = id.substring(0, 3) + "/" + id;
    if(!url.endsWith(id)) url += id;
    url += "/" + fileName;
    return url;
  }

  function embedRecorded(lvfContainer, identity, recordedFileUrl, link, errorHandler) {
    function createVideoTag() {
      var video = $('<video preload="auto" muted="muted" autoplay="autoplay" style="width: 100%; height: 100%; cursor: pointer; display: none; background-color: #000"></video>').appendTo(lvfContainer);
      video.on("ended", function() {
        new Date().getTime()-this.src.match(/\?nc=(.*)$/)[1] > 3000 ? createVideoTag() : this.play()
      }).on("error", function() {
        hideVideoFeed(lvfContainer)
        if(typeof(errorHandler) == "function") errorHandler(); 
      }).on("play", function() {
        $(this).css("display", "block");
        lvfContainer.find("video").not(this).remove();
      }).on("contextmenu", function() {
        return false; 
      }).on("click", function() {
        document.location.href = link;
      }).on("canplay", function() {
        this.play();
      });

      video[0].src = recordedFileUrl + "?nc=" + new Date().getTime();
      video[0].load();
    }
    createVideoTag();
  }

  function embedCamplace(lvfContainer, identity, link) {
    jQuery.ajax({
      type: "GET", url: "//m.camplace.com/stream/prev.php?previewToken=" + identity, xhrFields: {
        withCredentials: false
        },
      crossDomain: true,
      dataType: "json"
      }).success(function (n) {
      if (n.Success) {
        lvfContainer.css({
          "background-color": "#000",
          "display":"flex"
        });
        var img = $("<img src=\""+n.PreviewLocation + ".jpg"+"?t="+Date.now()+"\" style=\"display:block;margin:auto;max-width:100%;max-height:100%\" />").appendTo(lvfContainer);
        img.data("img-base",n.PreviewLocation + ".jpg").on("click", function(){
          document.location.href = link;
          })
        .on("load", function(){
          $(this).attr("src",$(this).data("img-base")+"?t="+Date.now());
          });
        lvfContainer.data("camplace",identity);
        }
      })
  }

  /**
   * boxObj - jquery object, model box
   * params - javascript object, containing selectors of links and container for LiveVideoFeed (same map as passed to run function)
   * checkMouseLeave - automatically hide video when mouse leaves container
   * streamType - 0 - try recorded then live, 1 - live only, 2 - recorded only
   * errorHandler - callback for stream errors
   */
  function showVideoFeedBox(boxObj, params, checkMouseLeave, streamType, errorHandler) {
    var links = boxObj.find(params['link_rsel']),
        container = boxObj.find(params['thumbnail_rsel']),
        identity = boxObj.data('identity'),
        servURI = boxObj.data('servuri') || (location.protocol+'//'+document.location.host+':1935/webvideo/'+identity),
        galleryContext = boxObj.data('galleryContext'),
        link = (links.length != 0) ? links[0].href : document.location.href;

    showVideoFeed(container, identity, servURI, boxObj, params, link, checkMouseLeave, streamType, errorHandler, galleryContext);
    if (params['handler_rsel']) boxObj.find(params['handler_rsel']).on("mouseleave", function() {
      container.trigger("mouseleave.LiveVideoFeed");
    });
  }
  
  /**
   * container - jquery object, should have css position: absolute or relative
   * identity - performer identity, ex. host-1
   * servURI - rtmp url to connect
   * boxObj - jquery object, model box
   * params - config provided while init
   * link - link to be redirected by click on video
   * checkMouseLeave - automatically hide video when mouse leaves container
   * streamType - 0 - try recorded then live, 1 - depreceted, 2 - recorded only
   * errorHandler - callback for stream connection errors
   * galleryContext - http path to galleries folder or undefined (servURI will be parsed to build gallery context)
   */
  function showVideoFeed(container, identity, servURI, boxObj, params, link, checkMouseLeave, streamType, errorHandler, galleryContext) {
    if(container.find("#lvfContainer").length > 0) return;
    if(checkMouseLeave) {
      var leaveContainer = params['leavecontainer_rsel'] ? boxObj.find(params['leavecontainer_rsel'])
                                                         : container;
      container.off("mouseleave.LiveVideoFeed");
      container.on("mouseleave.LiveVideoFeed", function() {
        var mouseLeaveHandler = arguments.callee;
        $(document).on("mousemove.LiveVideoFeed", function(event) {
          var pos = leaveContainer.offset(), w = leaveContainer.innerWidth(), h = leaveContainer.innerHeight();
          if(event.pageX < pos.left || event.pageX >= pos.left + w || event.pageY < pos.top || event.pageY >= pos.top + h) {
            container.off("mouseleave.LiveVideoFeed", mouseLeaveHandler);
            $(document).off("mousemove.LiveVideoFeed", arguments.callee);
            hideVideoFeed(container.find("#lvfContainer"));
          }
        });
      });
    }
    
    var lvfContainer = $('<div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 200; pointer-events: none" id="lvfContainer"></div>').appendTo(container);

    // camplace motion jpeg
    if (servURI.indexOf("vidclients.proxinity.net")!=-1) {
      embedCamplace(lvfContainer, identity, link, errorHandler);
    } else {
      lvfContainer.css({
        "background-image": 'url("' + getGalleryFile(identity, servURI, galleryContext, "-1_" + lvfContainer.width() + "x" + lvfContainer.height() + ".jpg?nc=" + new Date().getTime()) + '"), ' + lvfContainer.css("background-image"),
        "background-size": "100% 100%, " + lvfContainer.css("background-size"),
        "background-repeat": "no-repeat, " + lvfContainer.css("background-repeat")
      });
      embedRecorded(lvfContainer, identity, getGalleryFile(identity, servURI, galleryContext, "-1.mp4"), link, errorHandler);
    }
  }

  function hideVideoFeed(lvfContainer) {
    lvfContainer.remove();
  }
  this.hideVideoFeed = hideVideoFeed;
  this.showVideoFeed = showVideoFeed;
  this.showVideoFeedBox = showVideoFeedBox;
  this.run = function(params) {
    params = $.extend({},opts, params);
    var autoStartCount = params['autoStartCount'] || opts['autoStartCount'] || 3,
        autoStartDuration = params['autoStartDuration'] || opts['autoStartDuration'] || 10000,
        streamType = typeof(params['streamType']) == 'undefined' ? 2 : params['streamType'],
        boxes = $(params['boxes_sel'] || opts['boxes_sel']).filter("[data-identity]");

    boxes.each(function() {
      var boxObj = $(this),
          timeout = null;

      boxObj.find(params['handler_rsel'] || params['thumbnail_rsel'] || opts['thumbnail_rsel']).on("mouseenter", function() {
        clearTimeout(timeout);
        timeout = setTimeout(function() { showVideoFeedBox(boxObj, params, true, streamType, undefined); }, 300);
      }).on("mouseleave.showVideoFeed_throttle",function() {
        clearTimeout(timeout);
        timeout = null;
      });
    });

    // Пока этот функционал законсервируем

    // setInterval(function() {
    //   var autoBoxes = boxes.filter(":not(.noLvfAutoStart)");
    //
    //   function showBox(box) {
    //     showVideoFeedBox(box, params, false, 2, function() {
    //       box.addClass("noLvfAutoStart");
    //     });
    //     box.find("#lvfContainer").attr("data-LiveVideoFeed_AutomaticallyStarted", new Date().getTime());
    //   }
    //
    //   function hideBox(lvfContainer) {
    //     lvfContainer.removeAttr("data-LiveVideoFeed_AutomaticallyStarted");
    //     hideVideoFeed(lvfContainer);
    //   }
    //
    //   autoBoxes.filter(":not(:has(#lvfContainer))").each(function() {
    //     var boxesToShow = autoStartCount - autoBoxes.has("#lvfContainer[data-LiveVideoFeed_AutomaticallyStarted]").length;
    //     var boxesWithoutVideo = autoBoxes.length - autoBoxes.has("#lvfContainer").length;
    //
    //     if(Math.random() * boxesWithoutVideo < boxesToShow) showBox($(this));
    //   });
    //
    //   if(autoBoxes.length - autoBoxes.has("#lvfContainer").length > 0) {
    //     autoBoxes.find("#lvfContainer").each(function() {
    //       var started = $(this).attr("data-LiveVideoFeed_AutomaticallyStarted");
    //       if(started < new Date().getTime() - autoStartDuration) {
    //         var boxesToShow = autoBoxes.filter(":not(:has(#lvfContainer))");
    //
    //         showBox($(boxesToShow[Math.floor(Math.random()*boxesToShow.length)]));
    //         hideBox($(this));
    //         return false;
    //       }
    //     });
    //   }
    // }, 1000);
  };
}

LiveVideoFeed.getInstance = function(settings) {
  if (!LiveVideoFeed.instance) LiveVideoFeed.instance = new LiveVideoFeed(jQuery, settings);
  return LiveVideoFeed.instance;
};